import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-slider', {
    month: {
        1: 'month',
        2: 'months',
    },
    year: {
        1: 'year',
        2: 'years',
    },
    value: 'Value',
});
